import { setPagination } from '../../../State/pagination';
import fetchCaveats from '../../../Services/fetchCaveats';

export default () => async (dispatch) => {

  dispatch(setPagination({ current: 1 }));
  dispatch(fetchCaveats());
  
}